const domain = window.location.href.split('#')[0].split('://')[0];
const host_domain = window.location.host;

export class Config {
    public static get cdlsU() {
        let k = '';
        const u = {
            b: '',
            is: '',
            waj: '',
            it: ''
        };
        for (let prop in u) {
            k += prop;
        }
        return k;
    }
    public static get cdlsP() {
        let k = '';
        const p = {
            a: '',
            dm: '',
            i: '',
            n: ''
        };
        for (let prop in p) {
            k += prop;
        }
        return k;
    }
    public static CONSTANTS: any = {
        SUCCESS: 'success',
        GAUGEMIN: 0,
        GAUGEMAX: 100000,
        MQTT: {
            ip: host_domain,
            port: '443',
            // port: domain === 'http' ? '443' : '443',
            userName: Config.cdlsU,
            password: Config.cdlsP,
            useSSL: domain === 'http' ? false : true,
            rfidUserName: '',
            rfidPassword: '',
        },
    };
}